import { createTheme, type Theme } from '@mui/material/styles';

import { getComponents } from './components';
import { darkPalette, lightPalette } from './palette';
import { shadows } from './shadows';
import { typography } from './typography';

export type ColorMode = 'light' | 'dark';
export type Direction = 'ltr' | 'rtl';

export function createAppTheme(mode: ColorMode, direction: Direction): Theme {
  const baseTheme = createTheme({
    direction,
    palette: mode === 'light' ? lightPalette : darkPalette,
    typography,
    ...(shadows ? { shadows } : {}),
    // Global border radius — the single source of truth for rounding. EVERY
    // card / button / chip / paper / input picks this up via MUI's default
    // styles or an explicit `theme.shape.borderRadius` reference in sx. No
    // hardcoded radius values: there are no pill (`999`) shapes in the app.
    shape: { borderRadius: 12 },
  });

  return createTheme(baseTheme, {
    components: getComponents(baseTheme),
  });
}

export { ThemeProvider } from './theme-provider';
export { useColorScheme } from './color-scheme';
